export default __webpack_public_path__ + "static/media/uploader-abbottLite-1.4bb9d9f2.png";